import { createAction, createSlice } from '@reduxjs/toolkit';
import { Reducers } from '@sda/enums/store';
import { extractSharedActions } from '@sda/utils/store';
import { createEntityAdapter } from '@client/store/entity.adapter';
import type { AddEditProductPayload } from '@sda/interfaces/reducer/products.reducer';
import type { GenericList } from '@sda/helpers/helpers.types';
import type { Product } from '@sda/interfaces/product';
import type { FetchDataType } from '@sda/sdk/interfaces';

// LISTENERS

export const startAddEditShowProduct = createAction<AddEditProductPayload>(`${Reducers.PRODUCTS}/startAddEditShowProduct`);
export const startDeleteShowProduct = createAction<string>(`${Reducers.PRODUCTS}/startDeleteShowProduct`);
export const startUpdateShowProductMessage = createAction<{ messageFromHost: string, productId: string }>(`${Reducers.PRODUCTS}/startUpdateShowProductMessage`);

/**
 * fetching
 */
export const startFetchRelatedProducts = createAction<string>(`${Reducers.PRODUCTS}/startFetchRelatedProducts`);
export const unsubscribeRelatedProducts = createAction<string>(`${Reducers.PRODUCTS}/unsubscribeRelatedProducts`);
export const startFetchShowProducts = createAction<string>(`${Reducers.PRODUCTS}/startFetchShowProducts`);
export const unsubscribeShowProducts = createAction<string>(`${Reducers.PRODUCTS}/unsubscribeShowProducts`);
export const startReorderShowProducts = createAction<GenericList<Pick<Product & FetchDataType, 'id' | 'sortOrder'>>>(`${Reducers.PRODUCTS}/startReorderShowProducts`);

export const productAdapter = createEntityAdapter<Product & FetchDataType>({
  sortComparer: (a, b) => a.sortOrder - b.sortOrder,
});

const productsSlice = createSlice({
  initialState: productAdapter.getInitialState(),
  name: Reducers.PRODUCTS,
  reducers: {
    ...extractSharedActions(productAdapter),
  },
});

export const {
  addOne: addProduct, updateOne: updateProduct, upsertOne: upsertProduct,
} = productsSlice.actions;

export default productsSlice.reducer;
